import { strDelimited } from "./split";

function strFormatChange(str) {
  let netArr = [];
  strDelimited(str).forEach(item => {
    if (/[^a-zA-Z0-9]/ig.test(item)) {
      netArr.push(`\\${item}`)
    } else {
      netArr.push(item);
    }
  });

  return netArr.join("");
}

/**
 *  string replace all
 * @param {string} str Raw string
 * @param {string} replacedChar Characters to be replaced or replaced reg
 * @param {string} replaceChar INew character to replace
 * @param {string} type replacedChar type "char" / "reg",default is "reg"
 */

function strReplaceAll(str, replacedChar, replaceChar, type = "reg") {

  const replacedReg = type === "reg" ? replacedChar : new RegExp(replacedChar, "gm");
  const targetStr = str.replace(replacedReg, replaceChar);

  if (typeof (targetStr) === "string") {
    return targetStr;
  } else {
    return str;
  }
  //str.split(replacedChar).join(replaceChar)
}
/**
 *Find the index of the NTH non-empty character in the string
 * @param {string} str original string
 * @param {number} n find the index of the nth non-empty character
 * @returns {number} index of the nth non-empty character, -1 if not found
 */
function findNthNonSpaceCharIndex(str, n) {
  let count = 0;
  for (let i = 0; i < str.length; i++) {
    if (str[i] !== ' ') {
      count++;
      if (count === n) {
        return i;
      }
    }
  }
  return -1;
}

/**
 * Replace the substrings in the string
 * @param {string} original original string
 * @param {number} start Replace the starting index
 * @param {number} end Replace the completed index
 * @param {string} replacement the replacement string
 * @returns {string} the new string
 */
function replaceSubstring(original, start, end, replacement) {
  return original.substring(0, start) + replacement + original.substring(end);
}
/**
 * Replace the string that meets the standard with the specified character of the same length
 * @param {string} str original string
 * @param {RegExp} replacedReg The regular expression to be replaced
 * @param {string} replaceChar the replacement string
 * @returns {string} the new string
 */
function strReplaceEqualLength(str, replacedReg, replaceChar) {
  let resStr = str;
  let matchArr = resStr.match(replacedReg);

  while (matchArr) {
    resStr = replaceSubstring(resStr, matchArr.index, matchArr.index + matchArr[0].length, replaceChar.repeat(matchArr[0].length));
    matchArr = resStr.match(replacedReg);
  }

  return resStr;
}
// console.log(strReplaceEqualLength("FCAM_A0_CLK", /(A0)|(A)/i, " ")) // "FC M_  _CLK"

export {
  strFormatChange,
  strReplaceAll,
  strReplaceEqualLength,
  findNthNonSpaceCharIndex
}